module.exports = __webpack_public_path__ + "img/top-fitness-bg.73b99e8.jpg";